<template>
    <div class="wrapper slim">
        <h3 class="block-title text-center" v-if="this.content.meta.title"><span class="block-title-content theme-tinted-border">{{this.content.meta.title}}</span></h3>
        <div class="row justify-content-center p-3 m-0">
            <div v-for="(service, index) in services" :key="index" class="col-12 col-md-4 service-item">
                <img v-if="service.icon_url" class="service-avatar-image" :src="service.icon_url"/>
                <div class="service-info">
                    <div class="provider-name">
                        {{service.name}}
                    </div>
                    <p class="provider-content" v-html="service.content"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['block', 'providerId', 'context'],

        data: function() {
            var content = JSON.parse(this.block.content);
            if (!content.services) {
                content.services = [];
            }

            return {
                id: this.block.id,
                content,
                informationBlock: this.block.information_block,
                services: content.services,
            };
        },
    }
</script>

<style lang="scss" scoped>

    .wrapper {
        padding-bottom: 24px;
    }

    .service-item {
        border-radius: 4px;
        padding: 12px;
        display: flex;
        background: #FFF;
    }

    .service-info {
        padding: 0 12px;
        position: relative;
        white-space: pre-line;
        width: 100px;
        flex-grow: 1;

        /deep/ * {
            white-space: pre-line;
            word-wrap: break-word;
        }
    }

    .service-info .provider-name {
        font-size: 18px;
        font-weight: bold;
    }

    .service-info .provider-content {
        font-size: 16px;
    }

    @media only screen and (max-width: 1280px) {
        .service-item {
            width: 50%;
        }
    }

    @media only screen and (max-width: 600px) {
        .service-item {
            width: 100%;
        }
    }

    .service-avatar-image{
        flex-grow: 0;
        width: 64px;
        min-width: 64px;
        height: 64px;
        min-height: 64px;
        overflow: hidden;
    }
    /deep/ .provider-content p {
        margin: 0;
    }
</style>